angular.module('app')
    .controller('aggiornamentoAdvCtrl', function (
    ) {
        var init = function () {

        }

        init();
    })